module.exports = "https://web-assets.ifttt.com/packs/media/icons/cloudy-night-24791754.png";